// @flow

import { componentFactory } from '../component-factory';

export const Message = componentFactory('p', () => null);
